export default "/assets/images/smoky-gray-sm.14b64ea198a25cc3.webp";